export enum LegalDocumentType {
  cancellationTerms = 5,
  useWebConditions = 1,
  legalAdvice = 2,
  privacyPolicies = 3,
  cookiesPolicies = 4,
}
